export default "__VITE_ASSET__Q3VU04Ii__"